import axios from 'axios';
import { oneOfMsg } from 'src/resources/lang/en/form_validation';
import { getToken, removeToken, removeLoggedInUserDetails } from './auth';

const BASE_URL = process.env.REACT_APP_API_URL
// const BASE_URL = 'http://127.0.0.1:8000/api'
// console.log(BASE_URL, 'from api')

const URLS = {

    login_with_credentials: 'auth/login',
    logout: '/logout',

    my_profile_pic: `my-profile-pic`,

    login_credentials: '/auth',
    my_profile: '/my-profile',
    departments: '/departments',
    department_add: '/departments',
    // department_delete: `/departments`,
    // branch: '/companies/1/branches',
    time_zone: `/timezones`,
    position_levels: `/position-levels`,
    reporting_head: `/employees`,
    employee_type: `/employee-types`,
    employee_add: `/users`,
    role_id: `/roles`,
    company: `/companies`,
    salutations: `/salutations`,
    employee_status: `/employee-status`,
    accommodation_type: `/accommodations/type`,
    daily_work_report: '/daily_work_report',
    organisation_tags: `/organisation/tags`,

    add_Assets: '/assets',
    employee_directory: '/employees/directory',
    template_list: '/templates',
    template_add: '/templates',
    template_delete: '/templates',
    kyc_document_list: '/employees/documents',
    employee_directory_with_kyc: '/employees/documents',
    download_employee_directory_with_kyc: '/employees/documents-download',
    myProfileEdit: `/my-profile`,
    myaccommodationAdd: `/my-profile/accommodations`,
    mycontactEdit: `/my-profile/contacts`,
    myexperience: `/my-profile/experiences`,
    myacademics: `/my-profile/academics`,
    noticeBoard: `/notice_board`,
    noticeBoardTypeList: `/notice_board/type`,
    noticeBoardPriorityList: `/notice_board/priority`,
    noticeBoardAdd: `/notice_board`,
    manageModuleList: `/departments/modules`,
    moduleMapping: `/departments/modules/admin`,
    employeeList: `/users`,
    work_place_preferences: `/work-place-preferences/autocomplete`,
    on_leave: `/on-leave`,
    daily_work_report_rating: `/daily_work_report/rating`,
    vouchers: `/vouchers`,
    add_balance: `/vouchers/add_balance`,
    genders: `/genders`,





}

const makeRequest = (url, method = "get", data = {}, onSuccess = () => { }, onError = () => { }, addAuthorizationHeader = true, addFormDataHeader = false) => {

    let headers = addAuthorizationHeader ? ({
        Authorization: `${getToken()}`
    }) : {}

    if (addFormDataHeader) {
        headers = { ...headers, "Content-Type": "multipart/form-data" }
    }

    const config = {
        method: method,
        url: url,
        headers: headers,
        baseURL: BASE_URL

    }
    if (method === 'get') {
        config.params = data
    } else {
        config.data = data
    }

    axios(
        config
    ).then(res => {

        onSuccess(res.data);
    }).catch(err => {


        onError(err);
        if (err.response) {

            if (err.response.status === 401) {
                // console.log('looged out user')
                removeLoggedInUserDetails()
                removeToken()
                window.location.assign('/login')
            }

            if (err.response.status === 403) {
                window.location.assign('/dashboard')
            }
            // client received an error response (5xx, 4xx)
        } else if (err.request) {
            console.log(err.request, 'request')
            // client never received a response, or request never left
        } else {
            console.log(err, 'other')
        }



    })
}

export const loginCredentials = (credentials, onSuccess, onError = () => { }) => {
    makeRequest(URLS.login_credentials, "post", { ...credentials }, onSuccess, onError, false)
}


export const logout = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.logout, "get", {}, onSuccess, onError)
}

export const myProfile = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.my_profile, "get", {}, onSuccess, onError)
}

export const myProfileEdit = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.myProfileEdit, "put", data, onSuccess, onError)
}

export const myProfilePicEdit = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.my_profile_pic, "put", data, onSuccess, onError)
}


export const myaccommodationAdd = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.myaccommodationAdd, "post", data, onSuccess, onError)
}

export const myaccommodationEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/my-profile/accommodations/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const myaccommodationDetail = (id, onSuccess, onError = () => { }) => {
    const urls = `/my-profile/accommodations/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const mycontactEdit = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.mycontactEdit, "put", data, onSuccess, onError)
}

export const myexperience = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.myexperience, "get", {}, onSuccess, onError)
}

export const myacademics = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.myacademics, "get", {}, onSuccess, onError)
}

export const departmentList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.departments, "get", {}, onSuccess, onError)
}

export const departmentAdd = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.department_add, "post", { ...data }, onSuccess, onError)
}

export const departmentDelete = (id, onSuccess, onError = () => { }) => {
    const urls = `/departments/${id}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}

export const branchList = (id, onSuccess, onError = () => { }) => {
    const urls = `/companies/${id}/branches`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const branchAdd = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/companies/${id}/branches`
    makeRequest(urls, "post", data, onSuccess, onError, true, true)
}

export const stateSelect = (id, onSuccess, onError = () => { }) => {
    const urls = `/countries/${id}/states`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const countriesSelect = (onSuccess, onError = () => { }) => {
    const urls = `/countries`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const timeZone = (id, onSuccess, onError = () => { }) => {
    const urls = `${URLS.time_zone}?country=${id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const branchView = (compantId, id, onSuccess, onError = () => { }) => {
    const urls = `/companies/${compantId}/branches/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError, true, true)
}

export const branchEdit = (id, companyId, data, onSuccess, onError = () => { }) => {
    const urls = `/companies/${companyId}/branches/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const employeeList = (departmentId, branchId, name, count, page, employeeType, employeeStatus, onSuccess, onError = () => { }) => {
    const urls = `/users?department=${departmentId}&branch=${branchId}&employee_type=${employeeType}&status=${employeeStatus}&name=${name}&count=${count}&page=${page}`
    makeRequest(urls, "get", {}, onSuccess, onError, true, true)
}

export const positionLevel = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.position_levels, "get", {}, onSuccess, onError)
}

export const reportingHead = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.reporting_head, "post", { ...data }, onSuccess, onError)
}

export const employeeType = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.employee_type, "get", {}, onSuccess, onError)
}

export const employeeAdd = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.employee_add, "post", data, onSuccess, onError)
}

export const genderList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.genders, "get", {}, onSuccess, onError)
}

export const employeeWorkPlacePreferences = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.work_place_preferences, "get", {}, onSuccess, onError)
}

export const employeeOnVacationStatus = (data, onSuccess, onError = () => { }) => {
    // console.log(data, 'from api')
    makeRequest(URLS.on_leave, "put", data, onSuccess, onError)
}

export const employeeRating = (userId, onSuccess, onError = () => { }) => {
    const urls = `${URLS.daily_work_report_rating}?user_id=${userId}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}








export const roleId = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.role_id, "get", {}, onSuccess, onError)
}

export const employeeView = (id, onSuccess, onError = () => { }) => {
    const urls = `users/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError, true, true)
}

export const dailyWorkReport = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.daily_work_report, "post", data, onSuccess, onError)
}

export const employeeEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const companyDetail = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.company, "get", {}, onSuccess, onError)
}

export const companyEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/companies/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}


export const salutationsList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.salutations, "get", {}, onSuccess, onError)
}

export const employeeStatusList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.employee_status, "get", {}, onSuccess, onError)
}


export const academicList = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/academics`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const academicAdd = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/academics`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const academicEdit = (id, pk, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/academics/${pk}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const academicDetail = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/academics/${pk}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const academicDelete = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/academics/${pk}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}




export const workExpList = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/experiences`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const workExpAdd = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/experiences`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const workExpEdit = (id, pk, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/experiences/${pk}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const workExpDetail = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/experiences/${pk}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const workExpDelete = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/experiences/${pk}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}




export const employeeDetail = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const basicInfoEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/profile`
    makeRequest(urls, "put", { ...data }, onSuccess, onError)
}


export const accommodationType = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.accommodation_type, "get", {}, onSuccess, onError)
}


export const accommodationAdd = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/accommodations`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const accommodationEdit = (id, pk, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/accommodations/${pk}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const accommodationDetail = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/accommodations/${pk}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const accommodationDelete = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/accommodations/${pk}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}

export const contactInfoEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/contacts`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const kycDetail = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/kyc`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const kycEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/kyc`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const organizationDetail = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/organisation`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const employeeTypeTrails = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/employee-type/trails`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getEmployeeTypeList = (onSuccess, onError = () => { }) => {
    const urls = `/employee-types`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const organizationTrails = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/organisation/trails`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const organizationEdit = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/organisation`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const organizationTags = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.organisation_tags, "get", {}, onSuccess, onError)
}

export const offerLetterUpdate = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/organisation/offer-letter`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const offerJoiningUpdate = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/organisation/joining-letter`
    makeRequest(urls, "put", data, onSuccess, onError)
}



export const noticeBoardList = (type, onSuccess, onError = () => { }) => {
    const urls = `/notice_board?type_id=${type}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const noticeBoardTypeList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.noticeBoardTypeList, "get", {}, onSuccess, onError)
}

export const noticeBoardPriorityList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.noticeBoardPriorityList, "get", {}, onSuccess, onError)
}

export const noticeBoardAdd = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.noticeBoardAdd, "post", data, onSuccess, onError)
}

export const noticeBoardDelete = (id, onSuccess, onError = () => { }) => {
    const urls = `/notice_board/${id}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}

export const manageModuleList = (modules, onSuccess, onError = () => { }) => {
    const urls = `${URLS.manageModuleList}?modules=${modules}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const moduleMapping = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.moduleMapping, "put", data, onSuccess, onError)
}

export const allEmployeeList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.employeeList, "get", {}, onSuccess, onError)
}

export const employeeListByRole = (role, onSuccess, onError = () => { }) => {
    const urls = `/users/autocomplete?role=${role}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const employeeListByBranch = (branch, onSuccess, onError = () => { }) => {
    const urls = `/users/autocomplete?role=employee&branch=${branch}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const updateDepartmentTitle = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/departments/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const addCompliance = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/compliances`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const complianceDetail = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/compliances/${pk}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const complianceEdit = (id, pk, data, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/compliances/${pk}`;
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const complianceDelete = (id, pk, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/compliances/${pk}`
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const noticeBoardAdminList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/notice_board/filter?type_id=${filters.typeId}&status=${filters.status_id}&priority_id=${filters.priorityID}&from_date=${filters.fromDate}&to_date=${filters.toDate}&count=${filters.count_per_page}&page=${filters.page_number}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getCashVoucherBalanceList = (onSuccess, onError = () => { }) => {
    const urls = `/vouchers/cash`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getPolicyStatusList = (onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy/status`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getHolidayMasterList = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/holiday-master`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeaveEarnLog = (filter, onSuccess, onError = () => { }) => {
    const urls = `/leaves/user-leave-earn-logs?page=${filter.page}&count=${filter.count}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getleaveBalanceCount = (filter, onSuccess, onError = () => { }) => {
    const urls = `/leaves/balance/count?from_date=${filter.from_date}&to_date=${filter.to_date}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addHolidayMaster = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/holiday-master`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const deleteHolidayMaster = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/holiday-master/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const getHolidayPolicyList = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/calender/policies`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addHolidayCalendar = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/calender/policies`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const deleteHolidayCalendar = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/calender/policies/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const getHolidayPolicyData = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/holiday/${id}/mapping`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addHolidayToPolicy = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/holiday/mapping`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const deleteHolidayFromPolicy = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/holiday/mapping/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const updateHolidayPolicy = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/calender/update/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}



export const getWeekDaysList = (onSuccess, onError = () => { }) => {
    const urls = `/weekly/policy/weekdays`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getWeekCountList = (onSuccess, onError = () => { }) => {
    const urls = `/weekly/policy/weeks-in-month`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getWeeklyPolicyList = (onSuccess, onError = () => { }) => {
    const urls = `/weekly/policy`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const deleteWeeklyOffPolicy = (id, onSuccess, onError = () => { }) => {
    const urls = `/weekly/policy/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const addWeeklyPolicy = (data, onSuccess, onError = () => { }) => {
    const urls = `/weekly/policy`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getPkWiseWeeklyData = (id, onSuccess, onError = () => { }) => {
    const urls = `/weekly/policy/list/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const punchInApi = (data, onSuccess, onError = () => { }) => {
    const urls = `/attendance/punch-in`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const punchOutApi = (data, onSuccess, onError = () => { }) => {
    const urls = `/attendance/punch-out`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getDailyAttendatnceData = (onSuccess, onError = () => { }) => {
    const urls = `/attendance/my-today-status`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

















export const newsList = (filters, onSuccess, onError = () => { }) => {
    // console.log('from api',page, count );
    const urls = `/website/news?page=${filters.page}&is_homepage=&count=${filters.count}&is_homepage=${filters.is_homepage}&date=${filters.date}&title=${filters.title}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const newsDelete = (id, onSuccess, onError = () => { }) => {
    const urls = `/website/news/${id}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}

export const newsAdd = (data, onSuccess, onError = () => { }) => {
    const urls = `/website/news`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const getnewsPkList = (id, onSuccess, onError = () => { }) => {
    const urls = `/website/news/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const newsUpdate = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/website/news/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const getEmpDeptList = (onSuccess, onError = () => { }) => {
    makeRequest(URLS.my_profile, "get", {}, onSuccess, onError)
}


export const AddAssets = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.add_Assets, "post", data, onSuccess, onError, true, true)
}

export const ManagerViewDWR = (data, onSuccess, onError = () => { }) => {
    const urls = `/daily_work_report?count=${data?.count_per_page}&page=${data?.page_number}&date=${data.date}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const UpdateDwrRating = (id, data, onSuccess, onError = () => { }) => {
    const url = `/daily_work_report/${id}`
    makeRequest(url, "put", data, onSuccess, onError);
}

export const getAssetTypeList = (onSuccess, onError = () => { }) => {
    const urls = '/assets/types';
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const downloadAssetCSV = (filters, onSuccess, onError = () => { }) => {
    const urls = `/assets/downloads?asset_id=${filters.asset_id}&asset_category_id=${filters.asset_category_id}&asset_type_id=${filters.asset_type_id}&currently_assign_user_id=${filters.currently_assign_user_id}&asset_origin_id=${filters.asset_origin_id}&asset_status_id=${filters.asset_status_id}&branch_id=${filters.branch_id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getAssetOrigin = (onSuccess, onError = () => { }) => {
    const urls = '/assets/origin';
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getEmployeeDirectory = (data, onSuccess, onError = () => { }) => {
    const url = `${URLS.employee_directory}?page=${data.page}&count=${data.count}&name=${data.name}&branch=${data.branch}`
    makeRequest(url, "get", data, onSuccess, onError);
}

export const getAssetCategoryList = (onSuccess, onError = () => { }) => {
    const urls = '/assets/categories';
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getTemplates = (onSuccess, onError = () => { }) => {
    const url = URLS.template_list
    makeRequest(url, "get", {}, onSuccess, onError);
}

export const addTemplates = (data, onSuccess, onError = () => { }) => {
    const url = URLS.template_add
    makeRequest(url, "post", data, onSuccess, onError, true, true);
}

export const deleteTemplate = (id, onSuccess, onError = () => { }) => {
    const url = `${URLS.template_delete}/${id}`
    makeRequest(url, "delete", {}, onSuccess, onError);
}

export const kycDocumentList = (onSuccess, onError = () => { }) => {
    const url = URLS.kyc_document_list
    makeRequest(url, "get", {}, onSuccess, onError);
}

export const getEmployeeDirectoryWithKYCDocument = (data, onSuccess, onError = () => { }) => {
    const url = `${URLS.employee_directory_with_kyc}?page=${data.page}&count=${data.count}&name=${data.name}&branch=${data.branch}`
    makeRequest(url, "post", { documents: data.documents }, onSuccess, onError);
}

export const downloadEmployeeDirectoryWithKYCDocument = (data, onSuccess, onError = () => { }) => {
    const url = `${URLS.download_employee_directory_with_kyc}?name=${data.name}&branch=${data.branch}`
    makeRequest(url, "post", { documents: data.documents }, onSuccess, onError);
}

export const getAssetStatusList = (onSuccess, onError = () => { }) => {
    const urls = '/assets/status';
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getAssetList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/assets?count=${filters.count_per_page}&page=${filters.page_number}&asset_id=${filters.asset_id}&asset_category_id=${filters.asset_category_id}&asset_type_id=${filters.asset_type_id}&currently_assign_user_id=${filters.currently_assign_user_id}&asset_origin_id=${filters.asset_origin_id}&asset_status_id=${filters.asset_status_id}&branch_id=${filters.branch_id}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}


export const getDwrEmployeeDetail = (id, filters, onSuccess, onError = () => { }) => {
    const urls = `daily_work_report/employee_details?user_id=${id}&count=${filters.count_per_page}&page=${filters.page_number}`
    makeRequest(urls, "get", {}, onSuccess, onError = () => { })
}
export const getAssetUpgadationHistory = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/upgradation/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}
export const getBranchSelectList = (id, onSuccess, onError = () => { }) => {
    const urls = '/companies/1/branches/autocomplete';
    makeRequest(urls, "get", {}, onSuccess, onError) ///////////////////////////////////

}

export const getDepartmentSelectList = (id, onSuccess, onError = () => { }) => {
    const urls = '/departments/autocomplete';
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const updateEmployeeTypeAndStatus = (id, data, onSuccess, onError = () => { }) => {
    const urls = `users/${id}/employee-type`;
    makeRequest(urls, "put", data, onSuccess, onError, true, true)
}

export const helpDeskTicketList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/tickets?count=${filters.count_per_page}&page=${filters.page_number}&ticket_no=${filters.ticket_no}&from_date=${filters.from_date}&to_date=${filters.to_date}&department_id=${filters.department_id}&status_id=${filters.status_id}`;
    makeRequest(urls, 'get', {}, onSuccess, onError)
}

export const helpDeskRaiseTicket = (data, onSuccess, onError = () => { }) => {
    const urls = `/tickets`;
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const helpDeskTicketData = (id, onSuccess, onError = () => { }) => {
    const urls = `/tickets/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const helpDeskAddDiscussion = (data, onSuccess, onError = () => { }) => {
    const urls = `/tickets/discussions`;
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const getHelpDeskStatusList = (onSuccess, onError = () => { }) => {
    const urls = `/tickets/status`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const helpDeskAdminTicketList = (role, filters, onSuccess, onError = () => { }) => {
    const urls = `tickets/${role}?count=${filters.count_per_page}&page=${filters.page_number}&ticket_no=${filters.ticket_no}&from_date=${filters.from_date}&to_date=${filters.to_date}&department_id=${filters.department_id}&status_id=${filters.status_id}`;
    makeRequest(urls, 'get', {}, onSuccess, onError)
}

export const resolveTicket = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/tickets/admin/${id}`;
    makeRequest(urls, "put", data, onSuccess, onError);
}

export const adminDepartmentList = (onSuccess, onError = () => { }) => {
    const urls = `/tickets/departments`;
    makeRequest(urls, 'get', {}, onSuccess, onError)
}

export const getDashboardCalendarData = (date, onSuccess, onError = () => { }) => {
    const urls = `/holiday-and-weekly-off/list?from_date=${date.start}&to_date=${date.end}`;
    makeRequest(urls, 'get', {}, onSuccess, onError)
}







export const getAssetOwnershipHistory = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/ownership/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const assignAsset = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/`
}

export const assetUpgrade = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/upgradation`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const changeAssetCategory = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/categories`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const changeAssetStatus = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/status`
    makeRequest(urls, "post", data, onSuccess, onError);
}


export const getSoftwareAssetList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/assets/software?count=${filters.count_per_page}&page=${filters.page_number}&software_title=${filters.software_title}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getSoftwareTypeList = (onSuccess, onError = () => { }) => {
    const urls = "/assets/software_types"

    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const addSoftwareAsset = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/software`
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getAssetData = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getSoftwareAssetData = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/software/${id}`
    makeRequest(urls, 'get', {}, onSuccess, onError)
}

export const getMangerWiseEmployeeList = (filters, onSuccess, onError = () => { }) => {    //manager-wise employee-list
    const urls = `/daily_work_report/employees?count=${filters.count_per_page}&page=${filters.page_number}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmployeeDwrListHr = (filters, onSuccess, onError = () => { }) => {    //hr-wise employee-list
    const urls = `/daily_work_report/hr/all-employees?count=${filters.count_per_page}&page=${filters.page_number}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmployeeDwrList = (filter, onSuccess, onError = () => { }) => {
    const urls = `/daily_work_report/employees/self?count=${filter.count}&page=${filter.page}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmpDetails = (id, onSuccess, onError = () => { }) => {
    const urls = `/daily_work_report/employee_details?user_id=${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}
export const getEmployeeList = (onSuccess, onError = () => { }) => {
    const urls = `/users/details`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const assignAssetApi = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/mapping`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const getSoftwareData = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/software/${id}`;
    makeRequest(urls, 'get', {}, onSuccess, onError)
}

export const getTitleFilter = (filters, onSuccess, onError = () => { }) => {
    const urls = `/assets/asset_list?asset_category_id=${filters.asset_category_id}&asset_type_id=${filters.asset_type_id}&asset_id=0&branch_id=${filters.branch_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const attachSoftware = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/software/attach`;
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const unattachSoftware = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/software/attach_list/${id}`
    makeRequest(urls, "delete", {}, onSuccess, onError)
}

export const updateSoftware = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/assets/software/${id}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const getEmployeeAssets = (onSuccess, onError = () => { }) => {
    const urls = `/assets/employees`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmployeeAssetsDataPk = (id, onSuccess, onError = () => { }) => {
    const urls = `/assets/employees/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const loginwithGmail = (data, onSuccess, onError = () => { }) => {
    const urls = '/gmail';
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const getComlianceList = (id, onSuccess, onError = () => { }) => {
    const urls = `/users/${id}/compliances`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const addAssetType = (data, onSuccess, onError = () => { }) => {
    const urls = `/assets/types`;
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const changeAssetBranch = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/assets/branch`
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const paymentModeList = (onSuccess, onError = () => { }) => {
    const urls = `/vouchers/payment_mode`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getTransactionTypeList = (onSuccess, onError = () => { }) => {
    const urls = `/vouchers/transaction_type`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getVoucherList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/vouchers?page=${filters.page}&count=${filters.count}&voucher_id=${filters.voucher_id}&from_date=${filters.from_date}&to_date=${filters.to_date}&transaction_type_id=${filters.transaction_type_id}&payment_mode_id=${filters.payment_mode_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getSuperAdminVoucherList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/view?page=${filters.page}&count=${filters.count}&voucher_id=${filters.voucher_id}&from_date=${filters.from_date}&to_date=${filters.to_date}&transaction_type_id=${filters.transaction_type_id}&payment_mode_id=${filters.payment_mode_id}&branch_id=${filters.branch_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getSuperAdminVoucherBalance = (branchId, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/balance/branch_level?branch_id=${branchId}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getSuperadminStatements = (filters, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/statements/month_wise?page=${filters.page}&count=${filters.count}&branch_id=${filters.branch_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getVoucherBalance = (onSuccess, onError = () => { }) => {
    const urls = `/vouchers/balance`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addVoucher = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.vouchers, "post", data, onSuccess, onError);
}

export const addVoucherBalance = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.add_balance, "post", data, onSuccess, onError);
}

export const uploadVoucherDocument = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/update/${id}`
    makeRequest(urls, "put", data, onSuccess, onError);
}

export const cashVoucherCancelStatusUpdate = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/view/update/${id}`
    makeRequest(urls, "put", data, onSuccess, onError);
}

export const cashVoucherDetail = (id, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/view/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const cashVoucherStatementDownload = (from_date, to_date, branchId, onSuccess, onError = () => { }) => {
    const url = `vouchers/downloads?from_date=${from_date}&to_date=${to_date}&branch_id=${branchId}`
    makeRequest(url, "get", {}, onSuccess, onError);
}


export const getStatementList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/statements?page=${filters.page}&count=${filters.count}&voucher_id=0`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getCashCoucherPkWiseStatementList = (from_date, to_date, page, count, voucher_id, tranTypeId, payment_mode_id, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/statements/month?page=${page}&count=${count}&from_date=${from_date}&to_date=${to_date}&voucher_id=${voucher_id}&transaction_type_id=${tranTypeId}&payment_mode_id=${payment_mode_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getSuperAdminCashVoucherPkWiseStatementList = (from_date, to_date, page, count, branch, voucher_id, tranTypeId, payment_mode_id, onSuccess, onError = () => { }) => {
    const urls = `/vouchers/statements/month/view?page=${page}&count=${count}&from_date=${from_date}&to_date=${to_date}&branch_id=${branch}&voucher_id=${voucher_id}&transaction_type_id=${tranTypeId}&payment_mode_id=${payment_mode_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getExpenseCategoryList = (onSuccess, onError = () => { }) => {
    const urls = `/expenses/category`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const downloadAllExpenseCSV = (filters, onSuccess, onError = () => { }) => {
    const url = `/expenses/downloads-csv?&expense_id=${filters.expense_id}&from_date=${filters.from_date}&to_date=${filters.to_date}&expense_status_id=${filters.status_id}&expense_category_id=${filters.category_id}&user_id=${filters.user_id}&branch_id=${filters.branch_id}`
    makeRequest(url, "get", {}, onSuccess, onError)
}

export const getExpenseTypeList = (onSuccess, onError = () => { }) => {
    const urls = `/expenses/type`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getExpenseStatusList = (onSuccess, onError = () => { }) => {
    const urls = `/expenses/status`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const addExpense = (data, onSuccess, onError = () => { }) => {
    const urls = `/expenses`;
    makeRequest(urls, "post", data, onSuccess, onError)
}

export const getEmployeeExpenseList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/expenses/list?page=${filters.page}&count=${filters.count}&expense_id=${filters.expense_id}&from_date=${filters.from_date}&to_date=${filters.to_date}&expense_status_id=${filters.status_id}&expense_category_id=${filters.category_id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getEmployeeExpenseDashBoardDetails = (onSuccess, onError = () => { }) => {
    const urls = `/expenses/employee/dashboard`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getExpenseData = (id, onSuccess, onError = () => { }) => {
    const urls = `/expenses/${id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const getExpenseList = (role, filters, onSuccess, onError = () => { }) => {
    const urls = `/expenses/${role}?page=${filters.page}&count=${filters.count}&expense_id=${filters.expense_id}&from_date=${filters.from_date}&to_date=${filters.to_date}&expense_status_id=${filters.status_id}&expense_category_id=${filters.category_id}&user_id=${filters.user_id}&branch_id=${filters.branch_id}`
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const updateExpenseStatus = (data, onSuccess, onError = () => { }) => {
    const urls = `/expenses/trail`
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const settleExpense = (data, onSuccess, onError = () => { }) => {
    const urls = `/expenses/settled`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const addExpenseWallet = (data, onSuccess, onError = () => { }) => {
    const urls = `/expenses/balance/history`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const updateExpense = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/expenses/employee/update/${id}`;
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const getWalletHistory = (filters, onSuccess, onError = () => { }) => {
    const urls = `/expenses/balance/history?count=${filters.count}&page=${filters.page}&user_id=${filters.user_id}&from_date=${filters.from_date}&to_date=${filters.to_date}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmployeeCurrentWalletBalance = (filters, onSuccess, onError = () => { }) => {
    const urls = `/expenses/employee/list?page=${filters.page}&count=${filters.count}&user_id=${filters.user_id}&branch_id=${filters.branch_id}&department_id=${filters.department_id}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeaveCategory = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/category`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeaveStatus = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/status`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeaveType = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/type`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeaveApplicationList = (filters, onSuccess, onError = () => { }) => {
    const urls = `/leaves?page=${filters.page}&count=${filters.count}&leave_no=${filters.leave_no}&from_date=${filters.from_date}&to_date=${filters.to_date}&leave_category_id=${filters.leave_category_id}&leave_status_id=${filters.leave_status_id}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getfinacialLeaveList = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/financial/list?from_date=${data.from_date}&to_date=${data.to_date}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getHalfDayTypeList = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/half-day-type`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeaveCalendarlist = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/financial/list`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addleaveApplication = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getLeaveStatusCount = (filter, onSuccess, onError = () => { }) => {
    const urls = `/leaves/status/count?from_date=${filter.from_date}&to_date=${filter.to_date}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getPkWiseLeaveData = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/list/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getModuleAdminLeavelist = (roleInfo, filters, onSuccess, onError = () => { }) => {
    const urls = `/leaves/${roleInfo.role_code == "employee" ? 'manager' : 'hr'}?page=${filters.page}&count=${filters.count}&leave_no=${filters.leave_no}&from_date=${filters.from_date}&to_date=${filters.to_date}&leave_category_id=${filters.leave_category_id}&leave_status_id=${filters.leave_status_id}&user_id=${filters.user_id}&branch_id=${filters.branch_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError)
}

export const updateLeaveStatus = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/logs`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getLeavePolicy = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/policy`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getCompoffList = (role, filters, onSuccess, onError = () => { }) => {
    const urls = `/leaves/comp-off${role}?page=${filters.page}&count=${filters.count}&from_date=${filters.from_date}&to_date=${filters.to_date}&user_id=${filters.user_id}&branch_id=${filters.branch_id}&comp_off_status_id=${filters.comp_off_status_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}
export const addTodoList = (data, onSuccess, onError = () => { }) => {
    const urls = `/to_do`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getToDoList = (onSuccess, onError = () => { }) => {
    const urls = `/to_do/list`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const deleteToDoTask = (id, onSuccess, onError = () => { }) => {
    const urls = `/to_do/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const addCompOffLeave = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/comp-off`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getCompOffStatusList = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/comp-off/status`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getPkWiseCompOffData = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/comp-off/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const updateCompoffStatus = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/comp-off/update/${id}`;
    makeRequest(urls, "put", data, onSuccess, onError);
}

export const getLeavesEarnList = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/earn`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeavePolicyPkWiseData = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/policy/list/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addLeavesPolicy = (data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/policy`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const editLeavesPolicy = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/leaves/policy/update/${id}`;
    makeRequest(urls, "put", data, onSuccess, onError);
}

export const deleteLeavesPolicy = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/policy/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const getBranchPolicyData = (id, onSuccess, onError = () => { }) => {
    const urls = `/branch/mapping/list?branch_id=${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const updateBranchPolciyData = (data, onSuccess, onError = () => { }) => {
    const urls = `/branch/mapping`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getAttendancePolciy = (onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getAttendanceCalendarList = (data, onSuccess, onError = () => { }) => {
    const urls = `/attendance/calendar/list?from_date=${data.from_date}&to_date=${data.to_date}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const deleteAttendancePolicy = (id, onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy/${id}`;
    makeRequest(urls, "delete", {}, onSuccess, onError);
}

export const addAttendnacePiolicy = (data, onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const updateAttendnacePiolicy = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy/update/${id}`;
    makeRequest(urls, "put", data, onSuccess, onError);
}

export const getRegularisationStatus = (onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/status/autocomplete`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getAttendanceStatusList = (onSuccess, onError = () => { }) => {
    const urls = `/attendance/status/autocomplete`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addRegularisationRequest = (id, data, onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/users/${id}`;
    makeRequest(urls, "post", data, onSuccess, onError);
}

export const getRegularisationListModuleAdmin = (filters, onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/approval?count=${filters.count}&page=${filters.page}&user=${filters.user}&status=${filters.status}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getRegularisationPkData = (id, onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const updateRegularisationStatus = (id, status, data, onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/${id}/${status}`
    makeRequest(urls, "put", data, onSuccess, onError)
}

export const getRegularisationListEmployee = (filters, onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/log?count=${filters.count}&page=${filters.page}&status=${filters.status}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getHrAttendanceLogs = (filters, onSuccess, onError = () => { }) => {
    const urls = `/attendance/users/log?count=${filters.count}&page=${filters.page}&user=${filters.user}&from_date=${filters.from_date}&to_date=${filters.to_date}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmployeeAttendanceLogs = (filters, onSuccess, onError = () => { }) => {
    const urls = `/attendance/log?count=${filters.count}&page=${filters.page}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getWorkingHoursList = (onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy/hours`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getAttendanceTimingList = (onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy/timing`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getAttendancePolicyPkData = (id, onSuccess, onError = () => { }) => {
    const urls = `/attendant/policy/list/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getDasboardPolicy = (onSuccess, onError = () => { }) => {
    const urls = `/branch/user/policy`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getProfileUrls = (onSuccess, onError = () => { }) => {
    const urls = `/profile/url`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEventList = (onSuccess, onError = () => { }) => {
    const urls = `/upcoming/events`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}


export const getHrDocsTypeList = (onSuccess, onError = () => { }) => {
    const urls = `/hr_documents/employee_document_types`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getEmployeeHrDocs = (id, docTypeId, onSuccess, onError = () => { }) => {
    const urls = `/hr_documents/employee_document/list?user_id=${id}&employee_document_type_id=${docTypeId}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const addMiscDocs = (data, onSuccess, onError = () => { }) => {
    const urls = `/hr_documents/miscellaneous`;
    makeRequest(urls, "post", data, onSuccess, onError);
}


//Approvals
export const getLeaveApprovalCount = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/manager/dashboard`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getDwrApprovalCount = (onSuccess, onError = () => { }) => {
    const urls = `/daily_work_report/manager/dashboard`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getExpenseApprovalCount = (onSuccess, onError = () => { }) => {
    const urls = `/expenses/manager/dashboard`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getRegularisationApprovalCount = (onSuccess, onError = () => { }) => {
    const urls = `/attendance/regularisation/manager/dashboard`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getLeavesFiscalYearList = (onSuccess, onError = () => { }) => {
    const urls = `/leaves/financial-years`
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getHrDashboardAttendanceList = (filter, onSuccess, onError = () => { }) => {
    const urls = `/attendance/list?page=${filter.page}&count=${filter.count}`
    makeRequest(urls, "get", {}, onSuccess, onError);
}













export const forgotPassword = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.forgot_password, "post", data, onSuccess, onError, false)
}

export const updatePassword = (data, onSuccess, onError = () => { }) => {
    makeRequest(URLS.update_password, "post", data, onSuccess, onError, false)
}

export const getManagerToApproveLeaveslist = (filters, onSuccess, onError = () => { }) => {
    const urls = `/leaves/pending-cancel/list?page=${filters.page}&count=${filters.count}&leave_no=${filters.leave_no}&from_date=${filters.from_date}&to_date=${filters.to_date}&leave_category_id=${filters.leave_category_id}&leave_status_id=${filters.leave_status_id}&user_id=${filters.user_id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}

export const getHrLeavesCount = (id, onSuccess, onError = () => { }) => {
    const urls = `/leaves/balance/count/${id}`;
    makeRequest(urls, "get", {}, onSuccess, onError);
}
